import { useState, useEffect } from 'react'
import { useLanguage } from '../../context/LanguageContext'
import './infoPage.css'

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000'

const InfoPage = ({ stepConfig }) => {
  const { language, tenantSlug, goNext, allTranslations } = useLanguage()
  const t = allTranslations[language] || allTranslations['en']

  const [page,    setPage]    = useState(null)
  const [loading, setLoading] = useState(true)
  const [error,   setError]   = useState(null)

  useEffect(() => {
    const pageId = stepConfig?.pageId
    if (!pageId || !tenantSlug) { setLoading(false); return }

    fetch(`${BACKEND_URL}/api/checkin/info-page/${pageId}?lang=${language}`, {
      headers: { 'X-Tenant-Slug': tenantSlug },
    })
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => { setPage(data); setLoading(false) })
      .catch(() => { setError(true); setLoading(false) })
  }, [stepConfig?.pageId, language, tenantSlug])

  if (loading) return (
    <div className="viGuard__infoPage">
      <p className="page-loading-text">{t.loading}</p>
    </div>
  )

  if (error || !page) return (
    <div className="viGuard__infoPage">
      <p className="page-loading-text">{t.loading}</p>
    </div>
  )

  return (
    <div className="viGuard__infoPage">
      <div className="viGuard__infoPage-content">
        {page.blocks.map((block, idx) => {
          if (block.type === 'heading') {
            return <h1 key={idx} className="gradient__text viGuard__infoPage-heading">{block.text}</h1>
          }
          if (block.type === 'paragraph') {
            return <p key={idx} className="viGuard__infoPage-paragraph">{block.text}</p>
          }
          if (block.type === 'image') {
            return (
              <figure key={idx} className="viGuard__infoPage-figure">
                <img src={block.url} alt={block.caption || ''} className="viGuard__infoPage-img" />
                {block.caption && <figcaption className="viGuard__infoPage-caption">{block.caption}</figcaption>}
              </figure>
            )
          }
          return null
        })}
      </div>
      <div className="viGuard__infoPage-action">
        <button type="button" onClick={goNext}>
          {t.next_button}
        </button>
      </div>
    </div>
  )
}

export default InfoPage
